'use client';

import { useContextHandler } from '@bss-portfolio-view-ui/shared-common-util-typescript';
import { AuthProviderContext } from './auth-provider-context';

export function useAuthProviderContext() {
  return useContextHandler(AuthProviderContext);
}
